<shared-external-cmr-agent-bar [showButtonBack]="showButtonBack" [tenantId]="tenantId"
    (clickBack)="onClickBack()"></shared-external-cmr-agent-bar>
<ng-container *ngIf="!uuidQR">
    <div class="block-center">
        <div class="header"></div>
        <div class="nouuid">
            No valid uuid
        </div>
    </div>
</ng-container>

<div class="container qrcmr" *ngIf="uuidQR">
    <div class="block-center">
        <shared-external-cmr-agent-police-qr-component [agent]="'police'" [uuidQR]="uuidQR" [optionExpanded]="optionExpanded" (optionExpandedChanged)="onOptionExpandedChanged($event)"></shared-external-cmr-agent-police-qr-component>
    </div>
</div>
<div class="signaturahardman">
    <img class="logoimg" src="/assets/images/HardmanLogoBlanc.png" alt="Hardman logo">
    <a href="https:hardman.app" target="_blank" class="powered">{{'GLOBAL.DESENVOLUPATPER' | translate}}</a>
</div>